(function () {
  function initCopy(root) {
    var btn = root.querySelector("[data-ea-copy]");
    if (!btn) return;
    var url = btn.getAttribute("data-ea-url") || window.location.href;

    btn.addEventListener("click", function () {
      var done = function () {
        var original = btn.textContent;
        btn.classList.add("is-copied");
        btn.textContent = "Copied";
        window.setTimeout(function () {
          btn.classList.remove("is-copied");
          btn.textContent = original;
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt("Copy this link", url);
        });
      } else {
        window.prompt("Copy this link", url);
      }
    });
  }

  function softenInlineImages(root) {
    var body = root.querySelector("[data-ea-body]");
    if (!body) return;
    body.querySelectorAll("img").forEach(function (img) {
      if (!img.getAttribute("loading")) img.setAttribute("loading", "lazy");
      img.removeAttribute("width");
      img.removeAttribute("height");
    });
  }

  function init(root) {
    if (!root || root.dataset.eaReady === "1") return;
    root.dataset.eaReady = "1";
    initCopy(root);
    softenInlineImages(root);
  }

  function boot() {
    document.querySelectorAll("[data-elfink-article]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector("[data-elfink-article]");
    if (root) {
      root.dataset.eaReady = "";
      init(root);
    }
  });
})();
